import { useState } from 'react';

const faqs = [
  {
    q: '羞羞动漫网的分集剧情准不准？',
    a: '我们按每一话单独整理简介，并补充关键剧情与伏笔说明。内容以剧情梳理为主，帮助你把握故事线走向，具体细节建议以原片为准。',
  },
  {
    q: '补番的时候怎么用分集简介最方便？',
    a: '你可以先看“剧情梳理”掌握整体故事线，再按话对照每话简介。想跳过回忆或过渡集时，直接看对应话数简介就能知道该不该看。',
  },
  {
    q: '追更党能看到最新一话的剧情吗？',
    a: '会。连载中的作品会在最新话更新后第一时间补充该话的分集简介与剧情要点，首页“热门分集”也会同步展示最新更新。',
  },
  {
    q: '分集简介会剧透吗？',
    a: '我们以剧情梳理与走向说明为主，会明确标注幕次与关键转折。如果你想尽量少被剧透，建议只看“每话讲了什么”的概述部分。',
  },
  {
    q: '会不会更新更多作品的每话简介？',
    a: '会持续扩充。我们会优先覆盖热门与口碑作品，也欢迎在“关于我们”页留言推荐你想补的番。',
  },
];

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map((f) => ({
    '@type': 'Question',
    name: f.q,
    acceptedAnswer: { '@type': 'Answer', text: f.a },
  })),
};

export default function FaqSection() {
  const [openIdx, setOpenIdx] = useState<number>(0);

  return (
    <section id="faq" className="mx-auto max-w-4xl scroll-mt-16 px-4 py-14 md:px-6 md:py-20">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />
      <div className="text-center">
        <span className="inline-flex items-center gap-1.5 text-xs font-medium uppercase tracking-wider text-accent-600">
          <i className="ri-question-line" /> 常见问题
        </span>
        <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">关于分集剧情，你可能想问</h2>
        <p className="mx-auto mt-2 max-w-2xl text-sm text-foreground-700 md:text-base">
          我们整理了一些使用羞羞动漫网时最常见的问题，帮你更快上手。
        </p>
      </div>

      <div className="mt-8 space-y-3">
        {faqs.map((f, i) => {
          const open = openIdx === i;
          return (
            <div
              key={f.q}
              className={`overflow-hidden rounded-lg border bg-background-50 transition-colors ${
                open ? 'border-primary-300' : 'border-background-200'
              }`}
            >
              <button
                type="button"
                onClick={() => setOpenIdx(open ? -1 : i)}
                className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left"
              >
                <span className="flex items-center gap-3 text-sm font-semibold text-foreground-900 md:text-base">
                  <span className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-xs font-bold ${open ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-600'}`}>
                    {i + 1}
                  </span>
                  {f.q}
                </span>
                <i className={`shrink-0 text-lg text-foreground-500 transition-transform ${open ? 'ri-subtract-line' : 'ri-add-line'}`} />
              </button>
              {open && (
                <div className="border-t border-background-200 px-5 py-4 pl-14">
                  <p className="text-sm leading-7 text-foreground-700">{f.a}</p>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
}